/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspectsquare2Inputs */

const en_cropaspectsquare2 = /** @type {(inputs: Cropaspectsquare2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Square`)
};

const de_cropaspectsquare2 = /** @type {(inputs: Cropaspectsquare2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadrat`)
};

/**
* | output |
* | --- |
* | "Square" |
*
* @param {Cropaspectsquare2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspectsquare2 = /** @type {((inputs?: Cropaspectsquare2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspectsquare2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspectsquare2(inputs)
	return de_cropaspectsquare2(inputs)
});
export { cropaspectsquare2 as "cropAspectSquare" }